export default __webpack_public_path__ + "static/media/Lviv_city.9bbf0c72.xlsx";